// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CircleCheckBigIcon,
  React,
  TriangleAlertIcon,
  UserPlusIcon,
  motion,
  useNavigate,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const RegisterAgentPage = () => {
  const [e, t] = React.useState({
      id: "",
      name: "",
      password: "",
      commissionRate: "",
    }),
    [n, r] = React.useState(false),
    [a, l] = React.useState(null),
    [c, d] = React.useState(false),
    f = useNavigate(),
    h = (v) => {
      const { name: j, value: N } = v.target;
      t((b) => ({
        ...b,
        [j]: N,
      }));
    },
    p = () => {
      if (!e.id || !e.name || !e.password || e.commissionRate === "")
        return (l("All fields are required"), false);
      if (!/^[A-Z0-9_]{3,20}$/.test(e.id))
        return (
          l(
            "Agent ID must be between 3-20 characters and can only contain uppercase letters, numbers, and underscores",
          ),
          false
        );
      if (e.password.length < 6) return (l("Password must be at least 6 characters long"), false);
      const j = parseFloat(e.commissionRate);
      return isNaN(j) || j < 0 || j > 1
        ? (l("Commission rate must be a number between 0.0 and 1.0"), false)
        : true;
    },
    g = async (v) => {
      var j, N, b;
      if ((v.preventDefault(), l(null), d(false), !!p()))
        try {
          r(true);
          const S = {
            id: e.id,
            name: e.name,
            password: e.password,
            commissionRate: parseFloat(e.commissionRate),
          };
          (await api.post("/admin/register", S),
            d(true),
            t({
              id: "",
              name: "",
              password: "",
              commissionRate: "",
            }),
            setTimeout(() => {
              f("/admin/agents");
            }, 2e3));
        } catch (S) {
          (console.error("Error registering agent:", S),
            console.error("Error response:", (j = S.response) == null ? undefined : j.data),
            l(
              ((b = (N = S.response) == null ? undefined : N.data) == null ? undefined : b.error) ||
                "Failed to register agent. Please try again.",
            ));
        } finally {
          r(false);
        }
    },
    y = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    };
  return (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <main className="admin-main">
        <motion.div initial={"hidden"} animate={"visible"} variants={y} className={"mb-8"}>
          <h1 className={"text-3xl font-bold text-gray-900 mb-2"}>{"Register New Agent"}</h1>
          <p className={"text-gray-600"}>{"Create a new agent account"}</p>
        </motion.div>
        {a && (
          <motion.div initial={"hidden"} animate={"visible"} variants={y} className={"mb-6"}>
            <div
              className={
                "bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md flex items-start"
              }
              role={"alert"}
            >
              <TriangleAlertIcon className={"h-5 w-5 mr-2 mt-0.5 flex-shrink-0"} />
              <div>
                <p className={"font-medium"}>{"Registration Failed"}</p>
                <p>{a}</p>
              </div>
            </div>
          </motion.div>
        )}
        {c && (
          <motion.div initial={"hidden"} animate={"visible"} variants={y} className={"mb-6"}>
            <div
              className={
                "bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded-md flex items-start"
              }
              role={"alert"}
            >
              <CircleCheckBigIcon className={"h-5 w-5 mr-2 mt-0.5 flex-shrink-0"} />
              <div>
                <p className={"font-medium"}>{"Agent Registered Successfully"}</p>
                <p>{"The new agent account has been created. Redirecting to agents list..."}</p>
              </div>
            </div>
          </motion.div>
        )}
        <motion.div initial={"hidden"} animate={"visible"} variants={y}>
          <div className={"bg-white rounded-2xl shadow-lg overflow-hidden p-6"}>
            <form onSubmit={g}>
              <div className={"mb-8"}>
                <div
                  className={
                    "flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mx-auto mb-4"
                  }
                >
                  <UserPlusIcon className={"h-8 w-8 text-purple-600"} />
                </div>
                <h2 className={"text-center text-xl font-semibold text-gray-800 mb-1"}>
                  {"Agent Information"}
                </h2>
                <p className={"text-center text-gray-500 text-sm"}>
                  {"Enter the details for the new agent"}
                </p>
              </div>
              <div className={"space-y-6"}>
                <div>
                  <label htmlFor={"id"} className={"block text-sm font-medium text-gray-700 mb-1"}>
                    {"Agent ID"}
                  </label>
                  <input
                    type={"text"}
                    id={"id"}
                    name={"id"}
                    placeholder={"e.g. CB_AGENT1"}
                    className={
                      "w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-purple-500 focus:border-purple-500"
                    }
                    value={e.id}
                    onChange={h}
                    required={true}
                  />
                  <p className={"mt-1 text-xs text-gray-500"}>
                    {"Use uppercase letters, numbers, and underscores only (e.g., CB_AGENT1)"}
                  </p>
                </div>
                <div>
                  <label
                    htmlFor={"name"}
                    className={"block text-sm font-medium text-gray-700 mb-1"}
                  >
                    {"Agent Name"}
                  </label>
                  <input
                    type={"text"}
                    id={"name"}
                    name={"name"}
                    placeholder={"Full Name"}
                    className={
                      "w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-purple-500 focus:border-purple-500"
                    }
                    value={e.name}
                    onChange={h}
                    required={true}
                  />
                </div>
                <div>
                  <label
                    htmlFor={"password"}
                    className={"block text-sm font-medium text-gray-700 mb-1"}
                  >
                    {"Password"}
                  </label>
                  <input
                    type={"password"}
                    id={"password"}
                    name={"password"}
                    placeholder={"Create a strong password"}
                    className={
                      "w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-purple-500 focus:border-purple-500"
                    }
                    value={e.password}
                    onChange={h}
                    required={true}
                  />
                  <p className={"mt-1 text-xs text-gray-500"}>
                    {"Password must be at least 6 characters long"}
                  </p>
                </div>
                <div>
                  <label
                    htmlFor={"commissionRate"}
                    className={"block text-sm font-medium text-gray-700 mb-1"}
                  >
                    {"Commission Rate"}
                  </label>
                  <input
                    type={"text"}
                    id={"commissionRate"}
                    name={"commissionRate"}
                    placeholder={"e.g. 0.05 for 5%"}
                    className={
                      "w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-purple-500 focus:border-purple-500"
                    }
                    value={e.commissionRate}
                    onChange={h}
                    required={true}
                  />
                  <p className={"mt-1 text-xs text-gray-500"}>
                    {"Enter a decimal value between 0.0 and 1.0 (e.g., 0.05 = 5%, 0.10 = 10%)"}
                  </p>
                </div>
              </div>
              <div className={"mt-8 flex flex-col sm:flex-row sm:justify-end gap-3"}>
                <button
                  type={"button"}
                  onClick={() => f("/admin/agents")}
                  className={
                    "px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                  }
                >
                  {"Cancel"}
                </button>
                <button
                  type={"submit"}
                  className={`px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors flex items-center justify-center ${n ? "opacity-70 cursor-not-allowed" : ""}`}
                  disabled={n}
                >
                  {n ? "Registering..." : "Register Agent"}
                </button>
              </div>
            </form>
          </div>
        </motion.div>
      </main>
    </div>
  );
};
export { RegisterAgentPage };
